// extracted by mini-css-extract-plugin
module.exports = {"root":"DraggableDialog_root__2Lxr7","header":"DraggableDialog_header__2otgs"};